import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Button } from '../dialog-buttons.component';

import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'close-designer-dialog',
    templateUrl: './close-designer-dialog.component.html',
    styleUrls: ['../dialog.scss'],
    standalone: false
})
export class CloseDesignerDialogComponent extends DialogComponent
{
  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
    this.buttons = {
      primary: Button.CONTINUE_DESIGNING,
      secondary: Button.RETURN_TO_HOME_PAGE,
    };
  }
}
